export default __webpack_public_path__ + "static/media/Logo_MetaMask_256h.dcbd2faa.png";